module.exports = __webpack_public_path__ + "img/hero-image-03-fi.9a47e5a6.png";